import React from "react";
import PolicyPage from "@/components/PolicyPage";

export default function TermsAndConditions() {
  return <PolicyPage docKey="terms" metaKey="terms" slug="terms" />;
}
